module.exports = __webpack_public_path__ + "static/media/in_a_week_7.0e4d0d0c.jpg";